export interface Feature {
  icon: string;
  title: string;
  text: string;
  iconAlt?: string;
  icon2?: string;
  icon2Alt?: string;
}

export const FEATURES: Feature[] = [
  {
    icon: '🎤',
    title: 'Удаление вокала',
    text: 'Чистый минус из любой песни — голос убираем, музыку оставляем.',
  },
  {
    icon: '🎥',
    title: 'Аудио и видео',
    text: 'Отправьте трек или видео — получите готовый инструментал.',
  },
  {
    icon: '/icons/YouTube_full-color_icon_(2017).svg',
    icon2: '/icons/Rutube_icon.svg',
    title: 'YouTube и Rutube ссылки',
    text: 'Кидайте прямые ссылки — не нужно выгружать файлы, бот сам скачает и обработает.',
    iconAlt: 'YouTube',
    icon2Alt: 'Rutube',
  },
  {
    icon: '📱',
    title: 'Рингтоны для мобил',
    text: 'Готовые рингтоны для Android (mp3, 30 сек) и iOS (m4r, 28 сек) — поставьте трек на звонок прямо из чата.',
  },
  {
    icon: '⚡',
    title: 'Быстро и просто',
    text: 'Один файл или ссылка — и за считанные минуты чистый звук без лишних настроек.',
  },
  {
    icon: '/icons/Telegram_logo.svg',
    title: 'Прямо в Telegram',
    text: 'Не нужно отдельное приложение — всё работает в боте, минусы скачиваются в один клик прямо из чата.',
    iconAlt: 'Telegram',
  },
];
